module.exports = __webpack_public_path__ + "static/media/map-marker-plus.6ef0b118.svg";